import React, { createContext, useContext, useState, ReactNode } from 'react';
type ModalType = 'demo' | 'talent' | 'rental' | null;
interface ModalContextType {
  activeModal: ModalType;
  openModal: (type: ModalType) => void;
  closeModal: () => void;
}
const ModalContext = createContext<ModalContextType | undefined>(undefined);
export function ModalProvider({
  children
}: {
  children: ReactNode;
}) {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const openModal = (type: ModalType) => setActiveModal(type);
  const closeModal = () => setActiveModal(null);
  return <ModalContext.Provider value={{
    activeModal,
    openModal,
    closeModal
  }} data-id="element-643" data-mp="21x8cunpv1pgw">
      {children}
    </ModalContext.Provider>;
}
export function useModals() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModals must be used within a ModalProvider');
  }
  return context;
}